import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {
  DialogRef,
  DialogService,
} from '@cyborg-monorepo/common/angular/cyborg-ui';
import { CalendlyService } from '../../modules/shared/services/calendly.service';
import { ReactivateDialogComponent } from './reactivate-dialog/reactivate-dialog.component';

@Component({ standalone: false, 
  templateUrl: './premium-gate.component.html',
  styleUrls: ['./premium-gate.component.scss'],
})
export class PremiumGateComponent {
  constructor(
    private dialogService: DialogService,
    private router: Router,
    private calendlyService: CalendlyService,
  ) {}

  public talkToCyborg(): void {
    this.calendlyService.talkToCyborg();
  }

  public openDialog(): void {
    const dialogRef: DialogRef = this.dialogService.open(
      ReactivateDialogComponent,
    );

    dialogRef.afterClosed().subscribe((redirect: boolean) => {
      if (redirect) {
        this.router.navigate(['research']);
      }
    });
  }
}
